import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

const CALENDLY_URL = 'https://calendly.com/ai-scale-hq/30min';

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <motion.header
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.5, ease: 'easeOut' }}
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-[#0E0F14]/90 backdrop-blur-lg border-b border-white/5 py-3' : 'py-5'
      }`}
      data-testid="header"
    >
      <div className="max-w-6xl mx-auto px-6 flex items-center justify-between">
        {/* Logo */}
        <a href="/" className="flex items-center gap-2" data-testid="header-logo">
          <div className="w-8 h-8 bg-[#6C4DFF] rounded-lg flex items-center justify-center">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M22 12h-4l-3 9L9 3l-3 9H2" />
            </svg>
          </div>
          <span className="text-xl font-bold text-white tracking-tight">
            Scale<span className="text-[#6C4DFF]">HQ</span>
          </span>
        </a>

        {/* Navigation */}
        <nav className="hidden md:flex items-center gap-8" data-testid="desktop-nav">
          <button onClick={() => scrollToSection('problem')} className="text-sm text-white/60 hover:text-white transition-colors">
            Problem
          </button>
          <button onClick={() => scrollToSection('solution')} className="text-sm text-white/60 hover:text-white transition-colors">
            Solution
          </button>
          <button onClick={() => scrollToSection('services')} className="text-sm text-white/60 hover:text-white transition-colors">
            Services
          </button>
        </nav>

        {/* CTA */}
        <a
          href={CALENDLY_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="hidden md:flex items-center gap-2 bg-[#6C4DFF] hover:bg-[#8468FF] text-white px-5 py-2.5 rounded-full text-sm font-medium transition-all"
          data-testid="header-cta"
        >
          Book a Call
        </a>
      </div>
    </motion.header>
  );
};
